import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React from "react";
import CustomButton from "../constant/commonButton";

const LicenseDialog = ({ open, onClose, licenseProof }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>License Proof</DialogTitle>
      <DialogContent>
        {licenseProof === "No Details" ? (
          <Typography>No Details</Typography>
        ) : (
          <iframe
            src={licenseProof}
            width="100%"
            height="500px"
            title="License Proof"
          />
        )}
      </DialogContent>
      <DialogActions>
        <CustomButton
          text="Close"
          size="XtraSmall"
          buttonStyle="style3"
          onClick={onClose}
        />
      </DialogActions>
    </Dialog>
  );
};

export default LicenseDialog;
